import './bootstrap';
import {initUsersIndex} from "./users";
import {initUsersCreate} from "./users/create";
import {initUsersEdit} from "./users/edit";
import {afterComponentLoadBootstrap} from "./bootstrap";
import {initViewComponentsExamples} from "../development/view-components/examples";
import {initPeopleIndex} from "./people";
import {initPeopleCreate} from "./people/create";
import {initPeopleEdit} from "./people/edit";
import {initProductionsIndex} from "./productions";
import {initCheckinsIndex} from "./checkins";
import {initCheckinsHistory} from "./checkins/history.js";
import {registerDevelopmentComponents} from "./development/registerDevelopmentComponents";
import {initEmailTemplatesIndex} from "./settings/emails";
import {initTemplatesIndex} from "./settings/templates";
import {updateCheckinCounts} from "./checkins/updateCheckinCounts";
import {initCheckinsStatus} from "./checkins/status";
import {initCheckinsReport} from "./checkins/report";
import {initProductionCreate} from "./productions/create";
import {initProductionEdit} from "./productions/edit";
import {initProductionRolesIndex} from "./productions/roles";
import {initPublicAuditionRequestIndex} from "../public/audition-requests";
import {initPublicAuditionChooseRolesIndex} from "../public/audition-requests/choose-roles";
import {initPublicAuditionChooseAuditionIndex} from "../public/audition-requests/choose-audition";
import {initPublicConfimSubmissionIndex} from "../public/audition-requests/confirm-submission";
import {initProductionAuditionRequestsIndex} from "./productions/audition-requests";
import {initPublicAuditionChooseConflictsIndex} from "../public/audition-requests/choose-conflicts";
import {initPublicVirtualAuditionIndex} from "../public/audition-requests/virtual-audition";
import {initProductionAuditionsScheduleIndex} from "./productions/auditions-schedule";
import {initProductionAuditionRequestsShow} from "./productions/audition-requests/show";
import {initOffSeasonPublicAuditionRequestIndex} from "../public/off-season-audition-requests";
import {initProductionRolesCreate} from "./productions/roles/create";
import {initProductionAuditionRequestsCreate} from './productions/audition-requests/create';
import {initProductionAuditionChooseConflictsIndex} from './productions/audition-requests/choose-conflicts';
import {initProductionAuditionChooseAuditionIndex} from './productions/audition-requests/choose-audition';
import {initProductionAuditionConfimSubmissionIndex} from './productions/audition-requests/confirm-submission';
import {initProductionManagePayIndex} from "./productions/manage-pay";
import {initPublicSignContractView} from "../public/contracts/sign-contract";
import {initProductionAuditionContractsIndex} from "./productions/audition-contracts";
import {initProductionAuditionContractsView} from "./productions/audition-contracts/view";
import {initProductionAuditionContractsList} from "./productions/audition-contracts/all-contracts-list";
import {initProductionAllConflictsIndex} from './productions/conflicts';
import {initProductionProcessCrewRequestsIndex} from "./productions/process-crew";
import {initProductionCastIndex} from './productions/cast/index';
import {initProductionRehearsalsIndex} from './productions/rehearsals/index';
import {initPeopleDetails} from "./people/details";
import {initProductionDirectorPageView} from "./productions/director-view";
import Swal from "sweetalert2";
import Axios from "axios";
import {loading} from "../helpers/loading";
import {initPublicAuditionHeadshotIndex} from "../public/audition-requests/headshot";

const componentMap = {
	'admin.users.index': {
		action: initUsersIndex,
	},
	'admin.users.create': {
		action: initUsersCreate,
	},
	'admin.users.edit': {
		action: initUsersEdit,
	},

	// Settings

	'admin.settings.emails.index': {
		action: initEmailTemplatesIndex
	},
	'admin.settings.templates.index': {
		action: initTemplatesIndex
	},

	/**
	 * People
	 */
	'admin.people.index': {
		action: initPeopleIndex,
	},
	'admin.people.create': {
		action: initPeopleCreate,
	},
	'admin.people.edit': {
		action: initPeopleEdit,
	},
	'admin.people.details': {
		action: initPeopleDetails,
	},

	/**
	 * Productions
	 */

	'admin.productions.index': {
		action: initProductionsIndex,
	},
	'admin.productions.create': {
		action: initProductionCreate,
	},
	'admin.productions.edit': {
		action: initProductionEdit,
	},
	'admin.productions.roles.index': {
		action: initProductionRolesIndex,
	},
	'admin.productions.auditions-schedule.index': {
		action: initProductionAuditionsScheduleIndex,
	},

	/**
	 * Production Roles
	 */

	'admin.productions.roles.create': {
		action: initProductionRolesCreate,
	},

	/**
	 * Production Audition Requests
	 */

	'admin.productions.audition-requests.index': {
		action: initProductionAuditionRequestsIndex,
	},

	'admin.productions.audition-requests.create': {
		action: initProductionAuditionRequestsCreate,
	},
	'admin.productions.audition-requests.show': {
		action: initProductionAuditionRequestsShow,
	},

	'admin.productions.audition-requests.choose-dates': {
		action: initProductionAuditionChooseAuditionIndex,
	},

	'admin.productions.audition-requests.choose-conflicts': {
		action: initProductionAuditionChooseConflictsIndex,
	},

	'admin.productions.audition-requests.confirm-submission': {
		action: initProductionAuditionConfimSubmissionIndex,
	},

	'admin.productions.process-crew.index': {
		action: initProductionProcessCrewRequestsIndex,
	},


	'admin.productions.manage-pay.index': {
		action: initProductionManagePayIndex,
	},

	// production conflicts
	'admin.productions.conflicts.index': {
		action: initProductionAllConflictsIndex,
	},

	// production rehearsals
	'admin.productions.rehearsals.index': {
		action: initProductionRehearsalsIndex,
	},

	/**
	 * Checkins
	 */

	'admin.checkins.index': {
		action: initCheckinsIndex,
	},
	'admin.checkins.history': {
		action: initCheckinsHistory,
	},
	'admin.checkins.status': {
		action: initCheckinsStatus,
	},
	'admin.checkins.report': {
		action: initCheckinsReport,
	},

	/**
	 * Audition contracts
	 */
	'admin.productions.audition-contracts.index': {
		action: initProductionAuditionContractsIndex,
	},
	'admin.productions.audition-contracts.view': {
		action: initProductionAuditionContractsView,
	},
	'admin.productions.audition-contracts.all-contracts-list': {
		action: initProductionAuditionContractsList,
	},

	/**
	 * Director page
	 */
	'admin.productions.director-page.index': {
		action: initProductionDirectorPageView,
	},

	/**
	 * Cast and Crew
	 */
	'admin.productions.cast-crew.index': {
		action: initProductionCastIndex,
	},

	/**
	 * Development
	 */
	'development.view-components.examples': {
		action: initViewComponentsExamples
	},


	//// Public routes, move to their own file

	'public.production-audition.index': {
		action: initPublicAuditionRequestIndex,
	},
	'public.production-audition.choose-roles': {
		action: initPublicAuditionChooseRolesIndex,
	},
	'public.production-audition.choose-dates': {
		action: initPublicAuditionChooseAuditionIndex,
	},
	'public.production-audition.choose-conflicts': {
		action: initPublicAuditionChooseConflictsIndex,
	},
	'public.production-audition.headshot': {
		action: initPublicAuditionHeadshotIndex,
	},
	'public.production-audition.confirm-submission': {
		action: initPublicConfimSubmissionIndex,
	},

	'public.production-audition.virtual-audition': {
		action: initPublicVirtualAuditionIndex,
	},

	//// Off season requests
	'public.off-season-audition-request.index': {
		action: initOffSeasonPublicAuditionRequestIndex,
	},

	//// Public contract signing
	'public.contracts.sign': {
		action: initPublicSignContractView,
	}

};

// Register development components
registerDevelopmentComponents(componentMap);

document.addEventListener('DOMContentLoaded', () => {
	// Init components
	// noinspection JSUnresolvedReference
	if (window.jsComponents) {
		window.jsComponents.forEach(componentKey => {
			if (componentMap[componentKey]) {
				try {
					componentMap[componentKey].action();
				} catch (e) {
					console.log(`Error running component ${componentKey}`);
					console.error(e);
				}
			} else {
				console.error(`"${componentKey}" component not found`);
			}
		})
	}

	afterComponentLoadBootstrap()

	// Init checkin counts check
	if (window['isAdminArea']) {
		setInterval(() => {
			updateCheckinCounts();
		}, 60000)
	}

	// Keep session alive
	setInterval(keepSessionAlive, 900000); // 15 minutes
})

function keepSessionAlive() {
	Axios.post(window['routes/keep-session-alive'])
		.catch(() => {
			Swal.fire({
				icon: 'warning',
				text: 'The session has expired, please refresh the page',
				timer: 10000,
				confirmButtonText: 'Refresh',
			}).then(() => {
				loading();
				document.location.reload();
			})
		});
}
